import '../scss/frontend.scss';

/**
 * Call a specific function on a Youtube iframe player.
 * 
 * @see https://developers.google.com/youtube/iframe_api_reference#Playback_controls
 * @see https://developers.google.com/youtube/iframe_api_reference#Example_Video_Player_Constructors
 * 
 * @param {HTMLElement} iframe 
 * @param {string} func - Examples: 'playVideo', 'pauseVideo', 'stopVideo', etc.
 * @param {object} args 
 */
function controlYoutubeIframePlayer(iframe, func, args) {
	const src = iframe.getAttribute('src');
	
	if (!src || src.indexOf('youtube.com/embed') === -1) {
		return;
	}

	iframe.contentWindow.postMessage(JSON.stringify({
		'event': 'command',
		'func': func,
		'args': args || []
	}), "*");
}
window.controlYoutubeIframePlayer = controlYoutubeIframePlayer;

(function($){

	function isMobile(){
		return $(window).width() < 992;
	}

	function headerMobile(){
		if(isMobile()){
			$('header .wp-block-navigation-item.wp-block-navigation-submenu').addClass('--mobile');
			if($('.mobile-logo').length == 0){
				let sl = $('header .wp-block-site-logo').clone();
				let mm = $('header .wp-block-navigation__responsive-container-content');

				sl.addClass('mobile-logo');
				mm.before(sl);
			}
		}
		else{
			$('header .wp-block-navigation-item.wp-block-navigation-submenu').removeClass('--mobile');
			if($('.mobile-logo').length != 0) $('.mobile-logo').remove();
		}
	}

	$(document).ready(function(){

			/**
			 * Header Navigation handling
			 */
			let mp = $('.menu-phone');
			let li = $('header nav .main-nav > .wp-block-navigation-item:nth-last-child(1)');

			li.after(mp);

			$('header nav .wp-block-navigation__responsive-container-open').on('click', function(){
					$('.menu-phone').addClass('--mobile-open');
			});
			$('header .wp-block-navigation__responsive-container-close').on('click', function(){
				$('.menu-phone').removeClass('--mobile-open');
			});

			headerMobile();
			$('header .wp-block-navigation-item.wp-block-navigation-submenu').on('click', function(){
				if(!$(this).hasClass('--mobile')) return;
				$(this).toggleClass('--open');
				$(this).children('.wp-block-navigation__submenu-container').slideToggle(300);
			});

			/**
			 * Footer copyright year
			 */

			let year = new Date().getFullYear();
			$('#footer-copyright-year').text(year);
	});
	$(window).on('resize', function(){
		headerMobile();
	});
})(jQuery);